import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import {
  AllLoadingEquipmentContractorReport,
} from "../../../Apis/loadingEquipmentApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import Loader from "../../../Common/Loader/loader";
import ExcelJS from "exceljs";
import { AllOwnerTypeDetails } from "../../../Apis/ownerTypeApi";
import isGHMC from "../../../Common/helper/helpar";
import TableSkeleton from "../../AllotedMaster/TableSkeleton";
const ContractorWiseLoadingReport = ({ t }) => {
  const headers = [
    "contractorName",
    "NoOfDays",
    "WorkingHours",
    "deductHours",
    "avgVehiclesDeployedPerDay",
    "avgWorkingHours",
    "avgBreakdownHours",
    "avgDaysPerVehicle",
  ];
 
  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [optionsValues, setOptionsValues] = useState([]);
  const [selectedOwnerType, setSelectedOwnerType] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(getCurrentMonth());
  const [selectedYear, setSelectedYear] = useState(getCurrentYear());
  const isProd = isGHMC();
  useEffect(() => {
    const fetchOwnerTypeData = async () => {
      try {
        const ownerTypeData = await AllOwnerTypeDetails();
        setOwnerTypeDetails(ownerTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };
    fetchOwnerTypeData();
  }, []);
 
  useEffect(() => {
    setOptionsValues(ownerTypeDetails.map(ownerType => ({
      value: ownerType.ownerTypeId,
      label: ownerType.ownerTypeName,
    })));
  }, [ownerTypeDetails]);
 
  const handleMonthChange = (event) => {
    const [year, month] = event.target.value.split("-");
    setSelectedMonth(month);
    setSelectedYear(year);
  };
 
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    fetchTripsTonnageData(selectedMonth, selectedYear, selectedOwnerType);
  };
 
  const fetchTripsTonnageData = async (month, year, ownerType) => {
    try {
      setIsLoading(true);
      // Format month and year as "month,year"
      const formattedMonthYear = `${month},${year}`;
      const response = await AllLoadingEquipmentContractorReport(formattedMonthYear, ownerType);
      let formattedData = response.map((item) => ({
        ...item,
        contractorName: item.contractorName || "N/A",
        NoOfDays: item.noOfDays,
        WorkingHours: item.totalWorkingHours,
        deductHours: item.totalWorkedHours,
        avgBreakdownHours: item.avgBreakdownHours,
        avgVehiclesDeployedPerDay: item.avgVehiclesDeployedPerDay,
        avgDaysPerVehicle: item.avgDaysPerVehicle
      }));
      setAllTripsTonnage(formattedData);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };
 
  useEffect(()=>{
    fetchTripsTonnageData(selectedMonth, selectedYear, selectedOwnerType)
  },[])

  

  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1
      }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Contractor Wise  Monthly Report`;
    const downloadDateTime = `Contractor Wise Monthly  Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("ContractorWiseMonthlyReport");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 8); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 8; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Contractor Wise Monthly Report", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 8); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "Contractor Wise Monthly Report"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 8; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }



    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Contractor Name",
      "No Of Days",
      "Working Hours",
      "Deduct Hours",
      "Avg Vehicles Deployed Per Day",
      "Avg Working Hours",
      "AVG Breakdown Hours",
      "Avg Days Per Vehicle",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 14) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" } // Red background color
        };
      }
    });

    // Add data rows
    getAllTripsTonnage.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.contractorName?? "N/A",
        item.NoOfDays?? "N/A",
        item.WorkingHours?? "N/A",
        item.deductHours?? "N/A",
        item.avgVehiclesDeployedPerDay?? "N/A",
        item.avgWorkingHours?? "N/A",
        item.avgBreakdownHours?? "N/A",
        item.avgDaysPerVehicle?? "N/A",
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 14) {
          // Align the columns from 1 to 4 to the left
          cell.alignment = { horizontal: "left" };
        } else {
          // Align the rest of the columns to the center
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
      { width: 35 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
     
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ContractorWiseMonthlyReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
 
  return (
    <>
     
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
              <h4 className="text-start mb-3">{t("Contractor Wise Monthly Report")} </h4>
              <div className="card">
                <div className="card-body p-3">
                  <div className="row align-items-end">
                    <div className="col-md-12">
                      <form className="row align-items-end" onSubmit={handleFormSubmit} style={{ textAlign: "justify" }}>
                        <div className="col-md-3 ">
                          <label htmlFor="start">Month:</label>
                          <input
                            type="month"
                            id="start"
                            name="start"
                            min="2018-03"
                            style={inputStyle}
                            value={`${selectedYear}-${selectedMonth}`}
                            onChange={handleMonthChange}
                          />
                        </div>
                        <div className="col-md-2">
                          <label htmlFor="ownerType">Contractor Name:</label>
                          <select
                            id="ownerType"
                            name="ownerTypeId"
                          className="form-select"
                            value={selectedOwnerType}
                            onChange={(e) => setSelectedOwnerType(e.target.value)}
                          >
                            <option value="">Select</option>
                            {optionsValues.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-3 ">
                          <button type="submit" className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}>
                            Search
                          </button>
                        </div>
                        <div className="col-md-3">
                           <div className="text-end ">
                          <button className='btn-excel ms-auto mt-4' onClick={downloadAsExcel}>
                            <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                          </button>
                        </div>
                        </div>
                       
                      </form>
                    </div>
                  </div>
 
                  <div className="mt-3">
                   { isLoading ? <TableSkeleton /> : <TableComponent
                      DataFetchURL={getAllTripsTonnage}
                      headers={headers}
                      noPagination
                      noSearch
                      tableName="Contractor-wise Loading Report"
                    />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      
    </>
  );
};
 
// Utility functions to get current month and year
const getCurrentMonth = () => {
  const now = new Date();
  const month = now.getMonth() + 1;
  return month < 10 ? `0${month}` : month; // Ensure two digits format
};
 
const getCurrentYear = () => {
  return new Date().getFullYear();
};
 
// Inline styles for input and button
const inputStyle = {
  width: "100%",
  padding: "6px 12px",
  borderRadius: "4px",
  border: "1px solid #ccc",
};
 
const inputStyle2 = {
  backgroundColor: "#fff",
  height: "38px",
  border: "1px solid #E2E2E2",
  // padding: "15px",
  borderRadius: "0px",
};
const buttonStyle = {
  marginTop: "10px",
};
 
export default withTranslation()(ContractorWiseLoadingReport);